import { createFileRoute } from "@tanstack/react-router";
import { RelatorioFinanceiroProdutor } from "pages/relatorios/pages/financeiro_produtor";

export const Route = createFileRoute("/a/relatorios/financeiro-produtor")({
	component: RelatorioFinanceiroProdutor,
});
